import ModalComponent, { ModalHeader } from "@/components/Modal";
import QRCodeShare from "@/components/QRCodeShare";
import { cn } from "@/lib/utils";
import { assetPrefix } from "@/vars/assetUrl";
import homeUrl from "@/vars/homeUrl";
import shortUrl from "@/vars/shortUrl";
import {
  EllipsisVerticalIcon,
  ExclamationCircleIcon,
  PlusIcon,
  ShareIcon,
} from "@heroicons/react/24/solid";
import { CopyIcon } from "lucide-react";
import { Fragment, useEffect, useState } from "react";
import { useCopyToClipboard } from "react-use";

const MicrositeShareModal = (props) => {
  const [, copyCipboard] = useCopyToClipboard();
  const [isCopiedLink, setIsCopiedLink] = useState(false);
  const [isCopiedPlus, setIsCopiedPlus] = useState(false);
  const [eligibleSharebtn, setEligibleSharebtn] = useState(false);

  const { url, linkId, noBrand } = props;
  const menus = [
    {
      label: <strong>Create your own microsite</strong>,
      slug: "create",
      icon: "sid-neu-logo-single.svg",
    },
    {
      label: "Facebook",
      slug: "facebook",
      icon: "facebook-icon.svg",
    },
    {
      label: "Twitter X",
      slug: "twitter",
      icon: "twitter-logo-x.svg",
    },
    {
      label: "WhatsApp",
      slug: "whatsapp",
      icon: "whatsapp-icon.svg",
    },
    {
      label: isCopiedLink ? "Link has been copied" : "Copy URL",
      slug: "copy",
      icon: <CopyIcon className="size-5" />,
    },
    {
      label: isCopiedPlus ? "Link has been copied" : "Copy Plus URL",
      slug: "plus",
      icon: <PlusIcon className="size-5" />,
    },
    {
      label: "Share to Other",
      slug: "share-other",
      icon: <EllipsisVerticalIcon className="size-5" />,
    },
    {
      label: "Report Microsite",
      slug: "report",
      className: "text-red-500",
      icon: <ExclamationCircleIcon className="size-5" />,
    },
  ];

  const onShare = (item) => {
    const safeUrl = encodeURIComponent(url);

    if (item.slug === "create") {
      const reportUrl = `${homeUrl}/auth/register?&utm_source=sid-microsite&utm_medium=share-modal&utm_content=${props.slug}`;
      window.open(reportUrl, "_blank");
    }

    if (item.slug === "copy") {
      if (isCopiedLink) return;
      copyCipboard(url);
      setIsCopiedLink(true);
      setTimeout(() => setIsCopiedLink(false), 800);
    }

    if (item.slug === "plus") {
      if (isCopiedPlus) return;
      copyCipboard(url + "+");
      setIsCopiedPlus(true);
      setTimeout(() => setIsCopiedPlus(false), 800);
    }

    if (item.slug === "facebook") {
      createPopup(
        `http://www.facebook.com/sharer.php?u=${safeUrl}&t=${safeUrl}`,
        item.label
      );
    }

    if (item.slug === "twitter") {
      createPopup(
        `https://twitter.com/intent/tweet?text=${safeUrl}`,
        item.label
      );
    }

    if (item.slug === "whatsapp") {
      createPopup(`https://wa.me?text=${safeUrl}`, item.label);
    }
    if (item.slug === "report") {
      const reportUrl = `${homeUrl}/page/report?url=${encodeURIComponent(
        shortUrl + "/" + props.slug
      )}&utm_source=sid-microsite&utm_medium=share-modal&utm_content=${
        props.slug
      }`;
      window.open(reportUrl, "_blank");
    }
    if (item.slug === "share-other") {
      navigator.share({
        url: url,
        title: props.title,
      });
    }
  };

  const createPopup = (url, name) => {
    const winHeight = 400;
    const winWidth = 600;
    const winTop = screen.height / 2 - winHeight / 2;
    const winLeft = screen.width / 2 - winWidth / 2;
    window.open(
      url,
      name,
      "top=" +
        winTop +
        ",left=" +
        winLeft +
        ",toolbar=0,status=0,width=" +
        winWidth +
        ",height=" +
        winHeight
    );
  };

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      typeof window?.navigator?.share !== "undefined"
    ) {
      if (props.isBuilder !== true) {
        setEligibleSharebtn(true);
      }
    }
  }, []);

  return (
    <ModalComponent {...props} drawer className="sm:max-w-[380px]">
      <ModalHeader {...props}>
        <ShareIcon className="inline-block -mt-1 mr-1 w-5" /> Share Microsite
      </ModalHeader>

      {noBrand ? <Fragment /> : <QRCodeShare url={url} linkId={linkId} />}

      <div className="mt-8">
        {menus
          .filter((item) => {
            if (item.slug === "share-other" && !eligibleSharebtn) return false;

            if (noBrand && item.slug === "report") return false;
            if (noBrand && item.slug === "create") return false;

            return true;
          })
          .map((item, index) => (
            <button
              key={index}
              className={cn(
                "w-full rounded-md mb-3 flex items-center bg-white border text-gray-800 overflow-hidden transition-all hover:scale-[1.02]"
              )}
              onClick={() => onShare(item)}
            >
              <div
                className={cn(
                  "size-14 flex justify-center items-center ",
                  item.className
                )}
              >
                {typeof item.icon === "string" ? (
                  <div
                    className={cn(
                      "relative",
                      item.slug === "create" ? "w-6" : "w-6"
                    )}
                  >
                    <img
                      src={assetPrefix + "images/" + item.icon}
                      alt={item.slug}
                    />
                  </div>
                ) : (
                  item.icon
                )}
              </div>
              <div className={cn("pl-3", item.className)}>{item.label}</div>
            </button>
          ))}
      </div>
    </ModalComponent>
  );
};

export default MicrositeShareModal;
